import { trialAccess } from "../luagate-access-policy";

/*
体験の人の画面で、行き先に錠と「受講生のみ」の札を付けるかの決まり。決めるのは許可の表 (luagate-access-policy) の「使う」の列だけで、
ここは画面の行き先 (クエリやハッシュ付き) から住所を取り出して表に聞く。見るだけはできるので、行き先そのものは変えない
*/

/** 体験の人の次の一歩。入会の相談のページ (体験中の制限の知らせ TrialRestrictionMessage と同じ先) */
export const TRIAL_CONSULT_URL = "https://yumesaku.tech/women/lp/counseling";

const BASE = "https://yumesaku.invalid";

/** 錠を付けるか決める住所の頭 (エンコードを解き、大文字小文字を問わずに見る)。ここに当たらない住所は公開の画面か外のサイトなので錠を付けない */
const MEMBER_AREA_PATH = /^\/(luagate|admin)(\/|\.|$)/i;

function decodedPath(pathname: string): string {
  try {
    return decodeURIComponent(pathname);
  } catch {
    return pathname;
  }
}

/** 体験の人がこの行き先を使えないとき true。外のサイト (Zoom など) は鍵を掛けない */
export function isTrialLockedHref(href: string): boolean {
  let url: URL;
  try {
    url = new URL(href, BASE);
  } catch {
    return true;
  }
  if (!MEMBER_AREA_PATH.test(decodedPath(url.pathname))) return false;
  // 表にはエンコードを解かない住所を渡す (表と一字一致しないものは使えない扱い)
  return !trialAccess(url.pathname).use;
}

/**
 * 本文に :::runnable (属性つき、字下げ、:: の書き方も含む) がありそうか。錠の帯を出すかの目安だけに使う。
 * 実行の口を閉じるのは MarkdownContent の lockRunnable (描く側と同じ remark の解釈) で、ここの判定に頼らない
 */
export function hasRunnableBlocks(markdown: string): boolean {
  return /(^|\n)[ \t>]*:{2,}runnable(?![\w-])/.test(markdown);
}
